import React from 'react';
import ReactMarkdown from 'react-markdown';

import LoadingDots from '_components/loading-dots';

import { TMessage } from '_modules/message/types/entity';

import Link from './link';
import { StyledMarkdown, StyledMessage } from './style';

interface Props {
  message: TMessage;
}

const Message = ({ message }: Props) => {
  const isUser = message.role === 'USER';

  if (message.pending) {
    return (
      <StyledMessage $isUser={isUser} $pending>
        <LoadingDots />
      </StyledMessage>
    );
  }

  return (
    <StyledMessage $isUser={isUser}>
      {isUser ? (
        message.content
      ) : (
        <StyledMarkdown>
          <ReactMarkdown components={{ a: Link }}>
            {message.content}
          </ReactMarkdown>
        </StyledMarkdown>
      )}
    </StyledMessage>
  );
};

export default Message;
